import baseDiscoverService from './base/baseDiscoverService.js';

const RUNNING_ASSESSMENT_STATUSES = ["generating_queries", "executing_queries", "aggregating"];
const createFullAssessment = (payload, config) => {
    return baseDiscoverService.post("api/reports/full-assessment", payload, config);
};
const createFreeReport = (payload, config) => {
    return baseDiscoverService.post("api/reports/free-report", payload, config);
};
const createAiDiscoverabilityAssessment = (payload, config) => {
    return baseDiscoverService.post("api/reports/full-assessment", payload, config);
};
/** @deprecated Use createFullAssessment instead */
const createSubjectSpecificAssessment = (payload, config) => {
    return baseDiscoverService.post("api/reports/full-assessment", payload, config);
};
const createReport = (payload, config) => {
    return baseDiscoverService.post("api/reports", payload, config);
};
const createMarketProfileReport = (payload, config) => {
    return baseDiscoverService.post("api/reports/market-profile", payload, config);
};
const continueAssessment = (assessmentId, payload, config) => {
    return baseDiscoverService.post(`api/reports/${assessmentId}/continue`, payload || {}, config);
};
const getAssessmentStatus = (assessmentId, config) => {
    return baseDiscoverService.get(`api/reports/${assessmentId}`, config);
};
const getAiDiscoverabilityReport = (id, config) => {
    return baseDiscoverService.get(`api/reports/${id}`, config);
};
const getAiDiscoverabilityReports = (params, config) => {
    var _a;
    const queryParams = ((_a = params === null || params === void 0 ? void 0 : params.ids) === null || _a === void 0 ? void 0 : _a.length) ? { ids: params.ids.join(",") } : undefined;
    return baseDiscoverService.get(`api/reports`, Object.assign(Object.assign({}, config), { params: queryParams }));
};
const getDiscoverSubjectTimeSeries = (subjectId, config) => {
    return baseDiscoverService.get(`api/subjects/${subjectId}/time-series`, config);
};
const getDiscoverSubjectTopSources = (subjectId, config) => {
    return baseDiscoverService.get(`api/subjects/${subjectId}/top-sources`, config);
};
const getDiscoverSubjectAreasOfConcern = (subjectId, config) => {
    return baseDiscoverService.get(`api/subjects/${subjectId}/areas-of-concern`, config);
};
const updateDiscoverOrganization = (organizationId, payload, config) => {
    return baseDiscoverService.put(`api/organizations/${organizationId}`, payload, config);
};
const updateDiscoverSubject = (subjectId, payload, config) => {
    return baseDiscoverService.put(`api/subjects/${subjectId}`, payload, config);
};
const createDiscoverSubject = (payload, config) => {
    return baseDiscoverService.post(`api/subjects`, payload, config);
};
const getDiscoverSubjectById = (subjectId, config) => {
    return baseDiscoverService.get(`api/subjects/${subjectId}`, config);
};
const getDiscoverSubjects = (params, config) => {
    return baseDiscoverService.get(`api/subjects`, Object.assign(Object.assign({}, config), { params }));
};
const getDiscoverOrganizations = (config) => {
    return baseDiscoverService.get(`api/organizations`, config);
};
const createDiscoverOrganization = (payload, config) => {
    return baseDiscoverService.post(`api/organizations`, payload, config);
};
const deleteDiscoverSubject = (subjectId, config) => {
    return baseDiscoverService.delete(`api/subjects/${subjectId}`, config);
};
const deleteDiscoverOrganization = (organizationId, config) => {
    return baseDiscoverService.delete(`api/organizations/${organizationId}`, config);
};
const requestDemoAccess = (payload, config) => {
    return baseDiscoverService.post("api/demo/access", payload, config);
};
const getTopCompetitors = (subjectId, assessmentId, config) => {
    const params = assessmentId ? { assessmentId } : undefined;
    return baseDiscoverService.get(`api/subjects/${subjectId}/top-competitors`, Object.assign(Object.assign({}, config), { params }));
};
const getWhiskerDistribution = (subjectId, assessmentId, config) => {
    const params = assessmentId ? { assessmentId } : undefined;
    return baseDiscoverService.get(`api/subjects/${subjectId}/whisker-distribution`, Object.assign(Object.assign({}, config), { params }));
};
const signupAiDiscover = (payload, config) => {
    return baseDiscoverService.post("auth/signup", payload, config);
};
const createAssessmentTemplate = (payload, config) => {
    return baseDiscoverService.post("api/assessment-templates", payload, config);
};
const updateAssessmentTemplate = (templateId, payload, config) => {
    return baseDiscoverService.put(`api/assessment-templates/${templateId}`, payload, config);
};
const getAssessmentTemplates = (params, config) => {
    return baseDiscoverService.get("api/assessment-templates", Object.assign(Object.assign({}, config), { params }));
};
const getAssessmentTemplate = (templateId, config) => {
    return baseDiscoverService.get(`api/assessment-templates/${templateId}`, config);
};
const toggleAssessmentTemplateStatus = (templateId, action, config) => {
    return baseDiscoverService.patch(`api/assessment-templates/${templateId}/${action}`, {}, config);
};
const forkAssessmentTemplateWithCollection = (templateId, payload, config) => {
    return baseDiscoverService.post(`api/assessment-templates/${templateId}/update-collection`, payload, config);
};
// ── Assessment Variable Collections ──
const VariableOverrideAction = {
    SET: "set",
    REMOVE: "remove",
};
const createAssessmentVariableCollection = (payload, config) => {
    return baseDiscoverService.post("api/assessment-variable-collections", payload, config);
};
const updateAssessmentVariableCollection = (collectionId, payload, config) => {
    return baseDiscoverService.put(`api/assessment-variable-collections/${collectionId}`, payload, config);
};
const seedBaseVariables = (collectionId, payload, config) => {
    return baseDiscoverService.post(`api/assessment-variable-collections/${collectionId}/seed-base-variables`, payload || {}, config);
};
const getAssessmentVariableCollection = (collectionId, config) => {
    return baseDiscoverService.get(`api/assessment-variable-collections/${collectionId}`, config);
};
const getAssessmentVariablesByAssessmentId = (assessmentId, config) => {
    return baseDiscoverService.get(`api/assessment-variables/${assessmentId}`, config);
};
const getBilling = (organizationId, config) => {
    return baseDiscoverService.get(`api/organizations/${organizationId}/billing`, config);
};
const getBillingSubscription = (organizationId, config) => {
    return baseDiscoverService.get(`api/organizations/${organizationId}/billing/subscription`, config);
};
const getBillingSubscriptions = (organizationId, config) => {
    return baseDiscoverService.get(`api/organizations/${organizationId}/billing/subscriptions`, config);
};
const getBillingPaymentMethods = (organizationId, config) => {
    return baseDiscoverService.get(`api/organizations/${organizationId}/billing/payment-methods`, config);
};
const getBillingInvoices = (organizationId, config) => {
    return baseDiscoverService.get(`api/organizations/${organizationId}/billing/invoices`, config);
};
const getBillingPlans = (organizationId, config) => {
    return baseDiscoverService.get(`api/organizations/${organizationId}/billing/plans`, config);
};
const createBillingSetupIntent = (organizationId, config) => {
    return baseDiscoverService.post(`api/organizations/${organizationId}/billing/setup-intent`, {}, config);
};
const createBillingSubscription = (organizationId, payload, config) => {
    return baseDiscoverService.post(`api/organizations/${organizationId}/billing/subscription`, payload, config);
};
const deleteBillingPaymentMethod = (organizationId, paymentMethodId, config) => {
    return baseDiscoverService.delete(`api/organizations/${organizationId}/billing/payment-methods/${paymentMethodId}`, config);
};
const cancelBillingSubscription = (organizationId, config) => {
    return baseDiscoverService.delete(`api/organizations/${organizationId}/billing/subscription`, config);
};
const reactivateBillingSubscription = (organizationId, config) => {
    return baseDiscoverService.patch(`api/organizations/${organizationId}/billing/subscription`, {}, config);
};
const markOrganizationAsEnterprise = (organizationId, config) => {
    return baseDiscoverService.put(`api/organizations/${organizationId}/billing/enterprise`, {}, config);
};

export { RUNNING_ASSESSMENT_STATUSES, VariableOverrideAction, cancelBillingSubscription, continueAssessment, createAiDiscoverabilityAssessment, createAssessmentTemplate, createAssessmentVariableCollection, createBillingSetupIntent, createBillingSubscription, createDiscoverOrganization, createDiscoverSubject, createFreeReport, createFullAssessment, createMarketProfileReport, createReport, createSubjectSpecificAssessment, deleteBillingPaymentMethod, deleteDiscoverOrganization, deleteDiscoverSubject, forkAssessmentTemplateWithCollection, getAiDiscoverabilityReport, getAiDiscoverabilityReports, getAssessmentStatus, getAssessmentTemplate, getAssessmentTemplates, getAssessmentVariableCollection, getAssessmentVariablesByAssessmentId, getBilling, getBillingInvoices, getBillingPaymentMethods, getBillingPlans, getBillingSubscription, getBillingSubscriptions, getDiscoverOrganizations, getDiscoverSubjectAreasOfConcern, getDiscoverSubjectById, getDiscoverSubjectTimeSeries, getDiscoverSubjectTopSources, getDiscoverSubjects, getTopCompetitors, getWhiskerDistribution, markOrganizationAsEnterprise, reactivateBillingSubscription, requestDemoAccess, seedBaseVariables, signupAiDiscover, toggleAssessmentTemplateStatus, updateAssessmentTemplate, updateAssessmentVariableCollection, updateDiscoverOrganization, updateDiscoverSubject };
